import { HistoryUpdatesItemType } from 'src/components/History/types';

export type EditKeysType =
    | 'ESHOP_RETURN_ID'
    | 'DESCRIPTION'
    | 'SHIPPER'
    | 'TRACKING_NUMBER'
    | 'SHIPPER_SERVICE_CODE'
    | 'ORDER_TYPE'
    | 'NOTE'
    | 'ESHOP_NOTE'
    | 'ORDER_ID'
    | 'TRANSPORT_PAID_BY'
    | 'SOURCE_SYS'
    | 'STATUS'
    | 'RETURNED_ORDER_PRODUCTS'
    | 'FILES';

export const EDIT_KEYS = [
    'ESHOP_RETURN_ID',
    'DESCRIPTION',
    'SHIPPER',
    'TRACKING_NUMBER',
    'SHIPPER_SERVICE_CODE',
    'ORDER_TYPE',
    'NOTE',
    'ESHOP_NOTE',
    'TRANSPORT_PAID_BY',
    'SOURCE_SYS',
    'STATUS',
    'RETURNED_ORDER_PRODUCTS',
    'FILES',
];

export const PROPERTY_EDIT_KEYS = ['FILES'] as const;

export type PropertyEditKeysType = (typeof PROPERTY_EDIT_KEYS)[number];

export const statusesTo: { [key: string]: string[] } = {
    awaiting: ['canceled'],
};

export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'ESHOP_RETURN_ID', translateKey: 'returnDetail.eshopReturnId' },
    { key: 'DESCRIPTION', translateKey: 'returnDetail.returnDescription' },
    { key: 'SHIPPER', translateKey: 'returnDetail.shipper' },
    { key: 'TRACKING_NUMBER', translateKey: 'returnDetail.trackingNumber' },
    { key: 'SHIPPER_SERVICE_CODE', translateKey: 'returnDetail.shipperServiceCode' },
    { key: 'ORDER_ID', translateKey: 'returnDetail.orderId' },
    { key: 'RMA', translateKey: 'returnDetail.rma' },
    { key: 'ESHOP_ORDER_ID', translateKey: 'returnDetail.eshopID' },
    { key: 'STATUS', translateKey: 'returnDetail.statusOfReturn' },
    { key: 'CREATED_AT', translateKey: 'returnDetail.createdAt', format: 'date' },
    { key: 'NOTE', translateKey: 'returnDetail.note' },
    { key: 'ESHOP_NOTE', translateKey: 'returnDetail.eshopNote' },
    { key: 'TRANSPORT_PAID_BY', translateKey: 'returnDetail.transportPaidBy' },
    { key: 'SOURCE_SYS', translateKey: 'returnDetail.sourceSys' },
    { key: 'CANCELED_AT', translateKey: 'returnDetail.canceledAt', format: 'date' },
    { key: 'CONFIRMED_AT', translateKey: 'returnDetail.confirmedAt', format: 'date' },
    { key: 'RECEIVED_AT', translateKey: 'returnDetail.receivedAt', format: 'date' },
    { key: 'ORDER_TYPE', translateKey: 'returnDetail.orderType' },
];

export const historyUpdatesSkladonUser: HistoryUpdatesItemType[] = [
    ...historyUpdates,
    { key: 'STOCK_POSITION', translateKey: 'returnDetail.stockPosition' },
    { key: 'DCIX_EXPORT', translateKey: 'returnDetail.dcixExport', format: 'date' },
    { key: 'PARTNER_ORDER_ID', translateKey: 'returnDetail.partnerOrderId' },
    { key: 'CREATOR_ID', translateKey: 'users.table.creatorId', format: 'number' },
    { key: 'ESHOP_KEY', translateKey: 'providerDetail.eshopKey' },
    { key: 'SENDER_NAME', translateKey: 'returnDetail.history.senderName' },
    { key: 'SENDER_STREET', translateKey: 'returnDetail.history.senderStreet' },
    { key: 'SENDER_CITY', translateKey: 'returnDetail.history.senderCity' },
    { key: 'SENDER_STATE', translateKey: 'returnDetail.history.senderState' },
    { key: 'SENDER_POSTCODE', translateKey: 'returnDetail.history.senderPostCode' },
    { key: 'SENDER_PHONE', translateKey: 'returnDetail.history.senderPhone' },
    { key: 'RECIPIENT_NAME', translateKey: 'returnDetail.history.recipientName' },
];

/** Keys never shown for CREATE history entries (still shown on EDIT). */
export const historyCreateHiddenKeys: string[] = ['ESHOP_KEY'];

export const historyProductUpdates: HistoryUpdatesItemType[] = [
    { key: 'NAME', translateKey: 'returnDetail.productTable.name' },
    { key: 'COUNT', translateKey: 'returnDetail.productTable.count', format: 'number' },
    { key: 'QUANTITY', translateKey: 'returnDetail.productTable.quantity', format: 'number' },
    { key: 'RECEIVED', translateKey: 'returnDetail.productTable.received', format: 'number' },
    { key: 'RETURN_REASON', translateKey: 'returnDetail.productTable.returnReason' },
    { key: 'RESOLUTION', translateKey: 'returnDetail.productTable.resolution' },
    { key: 'SERIAL_NUMBER', translateKey: 'receivingDetail.productTable.serialNumber' },
    { key: 'LINE_STATE', translateKey: 'receivingDetail.productTable.lineState' },
];

export const historyReturnFilesUpdates: HistoryUpdatesItemType[] = [
    { key: 'type', translateKey: 'returnDetail.attachmentsHistoryType' },
    { key: 'fileName', translateKey: 'returnDetail.attachmentsHistoryFileName' },
    { key: 'fileType', translateKey: 'returnDetail.attachmentsHistoryFileExtension' },
    { key: 'fileSize', translateKey: 'returnDetail.attachmentsHistoryFileSize', format: 'number' },
];

export const ORDER_COLUMNS_LOAD = ['ID', 'ESHOP_ORDER_ID', 'TRACKING_NUMBER', 'ORDER_TYPE'];

export const STORAGE_KEY = 'returnEditData';
